export default __webpack_public_path__ + "static/augenpermanence-leistung-der-augen-amd-9d42711aa0f977caa3e3a04131852cf9.jpeg";